import React from 'react';
import Slider from 'rc-slider';
import 'rc-slider/assets/index.css';
import { useState, useEffect } from 'react';
import { useAmazonInventoryCacheContext } from '../../../Context/Cache/AmazonInventory/AmazonInventoryCacheContext';
 
const AmazonPriceRangeSlider = ({ type }) => {
  const { setIsRangeChanged,  minMax, ranges, setRanges, setRange } = useAmazonInventoryCacheContext();
  const min = minMax[type][0];
  const max = minMax[type][1];
 
  // Local state for input values
  const [tempMin, setTempMin] = useState(ranges[type][0]);
  const [tempMax, setTempMax] = useState(ranges[type][1]);
 
  useEffect(() => {
    setTempMin(ranges[type][0]);
    setTempMax(ranges[type][1]);
  }, [ranges, type]);
 
  const handleSliderChange = (newRange) => {
    setRanges({
      ...ranges,
      [type]: newRange
    });
    setIsRangeChanged(true);
    setRange(type, newRange);
  };
 
  const handleInputChange = (e) => {
    const { id, value } = e.target;
    const newValue = Number(value);
 
    if (!isNaN(newValue)) {
      if (id === 'min-amount') {
        const validValue = Math.max(min, Math.min(newValue, max));
        setTempMin(validValue);
      } else if (id === 'max-amount') {
        const validValue = Math.min(max, Math.max(newValue, min));
        setTempMax(validValue);
      }
    }
  };
 
  const handleInputBlur = () => {
    const validMin = Math.max(min, Math.min(tempMin, tempMax));
    const validMax = Math.min(max, Math.max(tempMax, validMin));
 
    setRanges({
      ...ranges,
      [type]: [validMin, validMax]
    });
    setIsRangeChanged(true);
    setRange(type, [validMin, validMax]);
  };
 
 
  return (
    <div className="price-range-wrap" style={{width: "233px"}}>
      <div className="price-range">
        <Slider
          range
          min={minMax[type][0]}
          max={minMax[type][1]}
          defaultValue={minMax[type]}
          value={ranges[type]}
          onChange={handleSliderChange}
          trackStyle={{ backgroundColor: '#d8373e', height: 6 }}
          handleStyle={{
            borderColor: '#d8373e',
            height: 12,
            width: 12,
            marginLeft: 0,
            marginTop: -3,
            backgroundColor: '#d8373e',
          }}
          railStyle={{ backgroundColor: '#eeeeee', height: 6 }}
        />
      </div>
      <div className="">
        <div className="price-input d-flex align-items-center" style={{gap:type === "size" ? "0.2rem" : type === "nyc_msrp" ? "0.5rem" : "0.5rem"}}>
        <div className='d-flex align-items-center' >
            <label style={{ textAlign:"center" ,marginRight: type === "size" ? "0px" : type === "nyc_msrp" ? "-8px" : "0px", fontSize: "12px", width: type === "size" ? "57px" : type === "nyc_msrp" ? "65px" : "58px" }}>Min {type === "price" ? "Price in $" : type === "size" ? "Size" : type === "nyc_msrp" ? <><span style={{fontSize: "11.25px"}}> MSRP in $</span></> : ""}</label>
            <input type="number" step="0.01" id="min-amount" value={tempMin}
              onChange={handleInputChange}
              onBlur={handleInputBlur} style={{border: "1px solid black", padding: '0px', width: type === "size" ? "50px" : type === "nyc_msrp" ? "50px" : "50px", textAlign: "center"}} />
          </div>
 
          <div className='d-flex align-items-center'>
            <label style={{ textAlign:"center", marginRight:type === "size" ? "0px" : type === "nyc_msrp" ? "-8px" : "0px", fontSize: "12px", width: type === "size" ? "58px" : type === "nyc_msrp" ? "65px" : "58px" }}>Max {type === "price" ? "Price in $" : type === "size" ? "Size" : type === "nyc_msrp" ? <><span style={{fontSize: "11.25px"}}> MSRP in $</span></> : ""}</label>
            <input type="number" step="0.01" id="max-amount"  value={tempMax}
              onChange={handleInputChange}
              onBlur={handleInputBlur} style={{border: "1px solid black", padding: '0px', width: type === "size" ? "50px" : type === "nyc_msrp" ? "50px" : "50px", textAlign: "center"}}/>
          </div>
         
         
          {/* <input
            type="text"
            id="amount"
            value={`min: ${ranges[type][0]} - max: ${ranges[type][1]}`}
            readOnly
          /> */}
        </div>
      </div>
    </div>
  );
};
 
export default AmazonPriceRangeSlider;